import React from 'react';
import { Field } from 'formik';
import { FormattedMessage } from 'react-intl';
import { TextAreaWithValidation } from '../../../../../components/prime-formik';

const SuperProfilePublicDescriptionInput = () => {
  return (
    <div className="p-col-12">
      <FormattedMessage
        id="account.super-profiles.new.public-description.label"
        defaultMessage="Public job description"
      >
        {(text) => (
          <label className="field-label" htmlFor="publicDescription">
            <strong>{text}</strong>
          </label>
        )}
      </FormattedMessage>
      <FormattedMessage
        id="account.super-profiles.new.public-description.placeholder"
        defaultMessage="Enter the job description to be published in GROW"
      >
        {(text) => (
          <Field
            className="form-control width-full"
            component={TextAreaWithValidation}
            cols={40}
            rows={10}
            id="publicDescription"
            name="publicDescription"
            placeholder={text}
          />
        )}
      </FormattedMessage>
    </div>
  );
};

export default SuperProfilePublicDescriptionInput;
